// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import * as BootstrapVueModule from 'bootstrap-vue'
import router from './router'
import store from './store';

import * as VueAwesomeSwiperModule from 'vue-awesome-swiper'
import * as VueHighchartsModule from 'vue-highcharts';
import * as VueMomentModule from 'vue-moment';
import VueWait from 'vue-wait/src/vue-wait.js';

import ExComponents from './components';
import * as VueGridLayoutModule from 'vue-grid-layout';
import VueStarRating from './vendor/vue-star-rating';

import * as VueTourModule from 'vue-tour'

import 'es6-promise/auto';
import './style/theme.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'swiper/dist/css/swiper.css'
import 'vue2-animate/dist/vue2-animate.min.css';

const BootstrapVue = BootstrapVueModule.default || BootstrapVueModule;
const VueAwesomeSwiper = VueAwesomeSwiperModule.default || VueAwesomeSwiperModule;
const VueHighcharts = VueHighchartsModule.default || VueHighchartsModule;
const VueMoment = VueMomentModule.default || VueMomentModule;
const VueGridLayout = VueGridLayoutModule.default || VueGridLayoutModule;
const VueTour = VueTourModule.default || VueTourModule;

Vue.component('star-rating', VueStarRating);

Vue.use(VueHighcharts);
Vue.use(VueAwesomeSwiper);
Vue.use(BootstrapVue);
Vue.use(VueWait);
Vue.use(VueMoment);
Vue.use(VueGridLayout);
Vue.use(ExComponents);
Vue.use(VueTour);

import App from './App';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  store,
  router,
  wait: new VueWait({
    useVuex: true,              // Uses Vuex to manage wait state
    vuexModuleName: 'wait',      // Vuex module name
    registerComponent: true,     // Registers `v-wait` component
    componentName: 'v-wait',     // <v-wait> component name, you can set `my-loader` etc.
    registerDirective: true,     // Registers `v-wait` directive
    directiveName: 'wait',       // <span v-wait /> directive name, you can set `my-loader` etc.

  }),
  ...App,
});



// WEBPACK FOOTER //
// ./src/main.js